import { c as _c } from "react/compiler-runtime";
import React, { type ReactElement } from 'react';
import { type AvatarGroupProps } from './types';
import { AVATAR_GROUP_CLASS_NAME } from '../classNames';
import { StyledGridAvatarGroupRoot } from './styles';
import Avatar from '../Avatar';
const AvatarGroup = React.forwardRef<HTMLDivElement, AvatarGroupProps>((t0, ref) => {
  const $ = _c(36);
  let children;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      max: t1,
      size: t2,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
  } else {
    children = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const max = t1 === undefined ? 3 : t1;
  const size = t2 === undefined ? "medium" : t2;
  let T0;
  let extraAvatars;
  let hasExtraAvatars;
  let t10;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[5] !== children || $[6] !== max || $[7] !== props || $[8] !== ref || $[9] !== size) {
    const childrenArray = React.Children.toArray(children);
    const numberOfChildren = childrenArray.length;
    const maxAvatars = Math.min(numberOfChildren, max);
    extraAvatars = Math.max(numberOfChildren - max, numberOfChildren - maxAvatars, 0);
    hasExtraAvatars = extraAvatars > 0;
    T0 = StyledGridAvatarGroupRoot;
    t3 = hasExtraAvatars;
    t4 = AVATAR_GROUP_CLASS_NAME;
    t5 = max;
    t6 = size;
    t7 = numberOfChildren;
    t8 = props;
    t9 = ref;
    t10 = childrenArray.slice(0, maxAvatars);
    $[5] = children;
    $[6] = max;
    $[7] = props;
    $[8] = ref;
    $[9] = size;
    $[10] = T0;
    $[11] = extraAvatars;
    $[12] = hasExtraAvatars;
    $[13] = t10;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    T0 = $[10];
    extraAvatars = $[11];
    hasExtraAvatars = $[12];
    t10 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
    t8 = $[19];
    t9 = $[20];
  }
  let t11;
  if ($[21] !== extraAvatars || $[22] !== hasExtraAvatars || $[23] !== size) {
    t11 = hasExtraAvatars && <Avatar size={size} number={`+${extraAvatars}`} kind="number" />;
    $[21] = extraAvatars;
    $[22] = hasExtraAvatars;
    $[23] = size;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== T0 || $[26] !== t10 || $[27] !== t11 || $[28] !== t3 || $[29] !== t4 || $[30] !== t5 || $[31] !== t6 || $[32] !== t7 || $[33] !== t8 || $[34] !== t9) {
    t12 = <T0 hasExtraAvatars={t3} className={t4} max={t5} size={t6} numberOfChildren={t7} {...t8} ref={t9}>{t10}{t11}</T0>;
    $[25] = T0;
    $[26] = t10;
    $[27] = t11;
    $[28] = t3;
    $[29] = t4;
    $[30] = t5;
    $[31] = t6;
    $[32] = t7;
    $[33] = t8;
    $[34] = t9;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  return t12;
});
export default AvatarGroup;
export { AvatarGroup };